/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorRequestDialogComposer.vue?vue&type=template&id=01317707&scoped=true"
import script from "./DoctorRequestDialogComposer.vue?vue&type=script&lang=js"
export * from "./DoctorRequestDialogComposer.vue?vue&type=script&lang=js"
import style0 from "./DoctorRequestDialogComposer.vue?vue&type=style&index=0&id=01317707&scoped=true&lang=css"
import style1 from "./DoctorRequestDialogComposer.vue?vue&type=style&index=1&id=01317707&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01317707",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01317707')) {
      api.createRecord('01317707', component.options)
    } else {
      api.reload('01317707', component.options)
    }
    module.hot.accept("./DoctorRequestDialogComposer.vue?vue&type=template&id=01317707&scoped=true", function () {
      api.rerender('01317707', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/DoctorRequestDialogComposer.vue"
export default component.exports